import { MaterialReactTable } from "material-react-table";

import AllowanceActions from "@/features/allowance/components/table/AllowanceActions";
import AllowanceTableColumns from "@/features/allowance/components/table/AllowanceTableColumns";
import { AllowanceBaseModel } from "@/features/allowance/types/allowanceModels";
import { OverviewItemsModel } from "@/shared/components/baselineOverview/model/baselineOverviewModels";

export type AllowanceTableProps = {
  allowances: AllowanceBaseModel[];
  handleSaveCell: (
    original: AllowanceBaseModel,
    name: string,
    value: number | string
  ) => void;
  refetchAllowance: () => void;
  overviewItems: OverviewItemsModel[];
};

export default function AllowanceTable({
  allowances,
  handleSaveCell,
  refetchAllowance,
  overviewItems,
}: AllowanceTableProps) {
  const columns = AllowanceTableColumns({ handleSaveCell, overviewItems });
  return (
    <MaterialReactTable
      columns={columns}
      layoutMode="grid"
      data={allowances}
      enableTableFooter
      initialState={{
        density: "compact",
        columnPinning: {
          right: ["mrt-row-actions"],
        },
      }}
      positionToolbarAlertBanner="none"
      muiTableHeadCellProps={{
        sx: () => ({
          background: "var(--primary-color)",
          align: "center",
          color: "#fff",
          fontSize: "12px",
          overflowX: "hidden",
        }),
      }}
      enableClickToCopy
      muiTableBodyCellProps={{
        align: "right",
        sx: {
          border: "none",
          background: "#fff",
          "& .MuiButtonBase-root": {
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
          // Remove Material-UI button ripple effect completely
          "& .MuiTouchRipple-root": {
            display: "none",
          },
        },
      }}
      muiTableFooterCellProps={{
        sx: {
          background: "#fff",
        },
      }}
      muiBottomToolbarProps={{
        sx: {
          background: "#fff",
        },
      }}
      muiTableProps={{
        sx: {
          tableLayout: "fixed",
        },
      }}
      muiTableContainerProps={{
        sx: {
          maxHeight: 700,
          overflow: "auto",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "8px !important",
            backgroundColor: "#f5f5f5",
            height: "12px !important",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            backgroundColor: "#ccc",
            "&:hover": {
              backgroundColor: "#b3b3b3",
            },
            "&:active": {
              backgroundColor: "#808080",
            },
          },
        },
      }}
      editDisplayMode="cell"
      enableColumnResizing
      enableColumnActions={false}
      enableColumnFilters={false}
      enableTopToolbar={false}
      enablePagination
      enableSorting
      enableRowActions
      renderRowActions={({ row }) => (
        <AllowanceActions
          allowanceId={row.original.id}
          refetchAllowance={refetchAllowance}
        />
      )}
    />
  );
}
